module.exports = __webpack_public_path__ + "static/media/search_icon.f34b6c96.svg";